import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

export default function Layout() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" }); }, [pathname]);

  const isAuthPage = ["/login", "/register"].includes(pathname);
  const isDashboard = pathname.startsWith("/dashboard") || pathname.startsWith("/admin");

  return (
    <>
      {!isDashboard && <Navbar />}
      <main className={isAuthPage || isDashboard ? "" : "pt-20"}>
        <Outlet />
      </main>
      {!isAuthPage && !isDashboard && <Footer />}
    </>
  );
}
